import { GenericDataState, createSetFetchDataPendingReducer, createSetFetchDataSuccesReducer, createSetFetchDataErrorReducer } from "../generic/GenericDataReducers";
import RequestStatus from "types/general/requests/RequestStatus";
import { createSlice } from "@reduxjs/toolkit";
import { IDeliveryLine } from "types/backend_models/deliveries/IDeliveryLine";

const initialState: GenericDataState<IDeliveryLine[]> = {
	requestStatus: RequestStatus.idle,
	data: [],
	error: null
}

const slice = createSlice({
	name: "detail_lines",
	initialState: initialState,
	reducers: {
		setFetchDeliverylinesByDeliveryIdPending: createSetFetchDataPendingReducer(),
		setFetchDeliverylinesByDeliveryIdSucces: createSetFetchDataSuccesReducer(),
		setFetchDeliverylinesByDeliveryIdError: createSetFetchDataErrorReducer(),
	}
});

export const {
	setFetchDeliverylinesByDeliveryIdPending,
	setFetchDeliverylinesByDeliveryIdSucces,
	setFetchDeliverylinesByDeliveryIdError
} = slice.actions;

export default slice.reducer;